import React, {useState} from 'react';

import VerticalAccordion from '../VerticalAccordion/VerticalAccordion.js'
import './VerticalAccordionContainer.scss';
import ChapterOpener from '../../models/ChapterOpener/ChapterOpener.js';
import ProgressBar from '../ProgressBar'

const VerticalAccordionContainer = (props)=>{
    let data = props.data;

    const [state, setState] = useState('overview')

    return(
        <div className="componet_test">
                <div className="tracker">
                    <svg className="tracker-outline" height="50" width="444">
                        <polyline points={"0,50 0,25 25,0 444,0 444,25 419,50 0,50"} stroke="#78A1BB" stroke-width="2px" fill="none" />
                    </svg>
                    <div className={`tracker-btn ${state === 'overview' && 'current'}`}>
                        <p>OVERVIEW</p>
                    </div>
                    <div className={`tracker-btn center ${state === 'activity' && 'current'}`}>
                        <p>ACTIVITY</p>
                    </div>
                    <div className={`tracker-btn ${state === 'conclusion' && 'current'}`}>
                        <p>CONCLUSION</p>
                    </div>
                </div>
            {state === 'overview'&&
                <div>
                    <ChapterOpener data={data.opener} onComplete={()=>setState('activity')} />
                    <div className="progressbar">
                        <p>Progress</p>
                        <ProgressBar pct={33}/>
                    </div>
                </div>
            }
            {state === 'activity' &&
            <>
            <div className="accordian_holder">
                <VerticalAccordion data={data.tabs} style={"abc"}/>
            </div>
            <div>
                <div className="progressbar">
                    <p>Progress</p>
                    <ProgressBar pct={66}/>
                </div>
                <img 
                    src={'/media/img/buttons/next-btn.png'}
                    alt="Next"
                    id={`next-button`}
                    className="next-button"
                    onClick={()=>setState('conclusion')}
                />
            </div>
            </>
            }
            {state === 'conclusion'&&
                <div>
                    <ChapterOpener data={data.opener} onComplete={()=>{}} />
                    <div className="progressbar">
                        <p>Progress</p>
                        <ProgressBar pct={100}/>
                    </div>
                </div>
            }

        </div>
    )
}

export default VerticalAccordionContainer;